export const EMPLOYEEWARNING_LOADING = "EMPLOYEEWARNING_LOADING";
export const EMPLOYEEWARNING_RESET = "EMPLOYEEWARNING_RESET";
export const GET_EMPLOYEEWARNING = "GET_EMPLOYEEWARNING";
export const GET_EMPLOYEEWARNING_SUCCESS = "GET_EMPLOYEEWARNING_SUCCESS";
export const GET_EMPLOYEEWARNING_FAIL = "GET_EMPLOYEEWARNING_FAIL";
export const DELETE_EMPLOYEEWARNING = "DELETE_EMPLOYEEWARNING"
export const DELETE_EMPLOYEEWARNING_SUCCESS = "DELETE_EMPLOYEEWARNING_SUCCESS"
export const DELETE_EMPLOYEEWARNING_FAIL = "DELETE_EMPLOYEEWARNING_FAIL"
export const UPDATE_EMPLOYEEWARNING = "UPDATE_EMPLOYEEWARNING"
export const UPDATE_EMPLOYEEWARNING_SUCCESS = "UPDATE_EMPLOYEEWARNING_SUCCESS"
export const UPDATE_EMPLOYEEWARNING_FAIL = "UPDATE_EMPLOYEEWARNING_FAIL"
export const ADD_NEW_EMPLOYEEWARNING = "ADD_NEW_EMPLOYEEWARNING"
export const ADD_EMPLOYEEWARNING_SUCCESS = "ADD_EMPLOYEEWARNING_SUCCESS"
export const ADD_EMPLOYEEWARNING_FAIL = "ADD_EMPLOYEEWARNING_FAIL"